import { AverageCaseRating, globals, Icon, Rating, saleTag } from 'common-ui';
import type { ProductCardProps } from './ProductCard';
import { CartButton } from '../AddToCart/Button';
import { formatCurrency } from '../../utils/formatCurrency';
import { productLinkBuilder } from 'common-next/src/components/common-functions';
import { getProductCardButtonText } from './ProductCard.utils';

const ProductInfoDefault = (props: ProductCardProps) => {
  const {
    productName,
    productRating,
    productReviewCount,
    productPrice,
    productPricePrefix,
    productPriceOriginal,
    productType,
    productVintage,
    referencedSkus = [],
    handleCmlpDLEvent,
  } = props || {};
  const { productCardVariant, productCardButton, productCode } = props || {};

  const fullBleedBackground = productCardVariant === 'Full bleed background';
  const isUS = globals.country === 'us';
  const isUSCase = isUS && productType === 'Case';

  const renderSaleTag = () =>
    saleTag(productVintage) && (
      <div className="product-sale-status">
        <Icon kind="sale" size="m" />
        <p className="product-on-sale-text">On Sale</p>
      </div>
    );

  const renderProductName = () => {
    const href = globals.brandId === 'amx' ? undefined : productLinkBuilder(productName, productVintage, productCode);

    const nameContent = fullBleedBackground ? (
      <label className="product-name">
        {productName} {productVintage}
      </label>
    ) : (
      <>
        {productName} {productVintage}
      </>
    );

    return (
      <div className="product-name-box">
        <a href={href} onClick={() => handleCmlpDLEvent?.('headline', undefined, href || '')}>
          {nameContent}
        </a>
      </div>
    );
  };

  const renderRating = () => {
    if ((isUS || globals.country === 'au') && referencedSkus.length > 0) {
      return <AverageCaseRating referencedSkus={referencedSkus} minRatingToShow={3.5} />;
    }

    if (!productRating && !productReviewCount) {
      return <div className="product-rating" />;
    }
    return (
      <div className="product-rating">
        {!!productRating && <Rating rating={productRating} />}
        {!!productReviewCount && <span>({productReviewCount})</span>}
      </div>
    );
  };

  const renderPricePrefix = () => {
    if (isUSCase && productPrice) {
      return (
        productPriceOriginal &&
        productPriceOriginal > productPrice && (
          <span className="original-price">{formatCurrency(productPriceOriginal)}</span>
        )
      );
    }
    return productPricePrefix || '';
  };

  const renderPrice = () =>
    productPrice && (
      <div className="product-price">
        {renderPricePrefix()}
        <span>{formatCurrency(productPrice)}</span>
        {isUSCase ? '' : ' each'}
      </div>
    );

  const renderButton = () => {
    if (!productCardButton) {
      return null;
    }

    const isAddToBasket = productCardButton.toLocaleLowerCase() === 'add to basket';

    return (
      <div className="product-card-button">
        {isAddToBasket ? (
          <CartButton
            itemCode={productCode}
            qty="1"
            buttonText={getProductCardButtonText(productCardButton)}
            hit={props.product}
          />
        ) : (
          <a href={productLinkBuilder(productName, productVintage, productCode)} className="view-product-button">
            {productCardButton}
          </a>
        )}
      </div>
    );
  };
  return (
    <div className="product-card-info">
      {renderSaleTag()}
      <div className="product-info-and-button">
        <div>
          {renderProductName()}
          {renderRating()}
          {renderPrice()}
        </div>
        {renderButton()}
      </div>
    </div>
  );
};

export default ProductInfoDefault;
